import type { TFunction } from 'i18next';
import type { AmountDifferenceType } from '../api/generated/model';

/**
 * AmountDifferenceType から翻訳済みラベルを取得する
 *
 * @param type - 差分タイプ
 * @param t - i18n翻訳関数
 */
export const getAmountDifferenceTypeLabel = ({
  type,
  t,
}: {
  type: AmountDifferenceType;
  t: TFunction;
}): string => {
  const labelMap = {
    increased: t('assessment.comparison-table.status.increased'),
    decreased: t('assessment.comparison-table.status.decreased'),
    unchanged: t('assessment.comparison-table.status.unchanged'),
    new: t('assessment.comparison-table.status.new'),
    deleted: t('assessment.comparison-table.status.deleted'),
  } as const satisfies Record<AmountDifferenceType, string>;

  return labelMap[type];
};
